export default "__VITE_ASSET__DUGKECMz__"